(function($) {
  
  /* MAPA DE INTERNET */

  $(".internet-coverage-map-pin").mouseover(function() {
      $(".internet-coverage-map-pin-description-mobile").html($(this).children(".internet-coverage-map-pin-description").html());
      $(".internet-coverage-map-pin-description-mobile").css('display', 'flex');
  });
  
  $(".internet-coverage-map-pin").mouseout(function() {
      //$(".internet-coverage-map-pin-description-mobile").html($(this).html());
      $(".internet-coverage-map-pin-description-mobile").css('display', 'none');
  });
  
})(jQuery);